import { ComposedTheme, createUseStyles } from '@glu/theming';
import registerDefaults from '../themeDefaults';

registerDefaults();

export default createUseStyles(
  ({
    accordion: {
      content: { color, fontFamily, fontWeight, lineHeight, size },
      transition: { transitionDelay, transitionDuration, transitionTimingFunction },
    },
  }: ComposedTheme) => ({
    '@global': {
      '.ReactCollapse--collapse': {
        transition: `height ${transitionDuration} ${transitionTimingFunction} ${transitionDelay}`,
      },
    },
    accordionContent: {
      fontFamily,
      fontSize: size,
      fontWeight,
      lineHeight,
      color,
      overflow: 'hidden',
      margin: [0, 0, 0, 25],
    },
  })
);
